import React, { useCallback, useState } from "react";
// イベント並べ替え
// app/controllers/concerns/search_concern.rbと一致
const sortEventKeys = {
  poplular: "popular",
  recently: "recently",
  weekend: "weekend",
  new: "new",
  circle: "circle",
  newCircle: "new_circle",
};
// 検索ワード補完
const searchTypes = { ec: "eventCondition", kw: "keyword" };
const searchCompletions = {
  人気イベント: {
    searchType: searchTypes.ec,
    sortEventKey: sortEventKeys.poplular,
  },
  オンライン: { searchType: searchTypes.kw },
};
const SearchFormForHeader = ({
  // categories,
  keyword,
  loadSearchResult,
}) => {
  const [keywordDisp, setKeywordDisp] = useState(keyword);
  // 補完（入力時に自動ロード）
  const onSearchCompletion = useCallback(
    (value) => {
      const sc = searchCompletions[value];
      if (sc.searchType === searchTypes.ec) {
        setKeywordDisp("");
        loadSearchResult({
          keyword: "",
          circleOrder: "",
          eventCondition: sc.sortEventKey,
          eventDate: null,
        });
        return false;
      } else if (sc.searchType === searchTypes.kw) {
        loadSearchResult({
          circleOrder: "",
          eventCondition: "",
          keyword: value,
        });
      }
    },
    [setKeywordDisp, loadSearchResult]
  );
  // キーワード入力
  const _onChangeKeyword = useCallback(
    (e) => {
      if (Object.keys(searchCompletions).indexOf(e.target.value) !== -1) {
        onSearchCompletion(e.target.value); // datalistタグ補完時に自動ロード
      }
      setKeywordDisp(e.target.value);
    },
    [onSearchCompletion, setKeywordDisp]
  );
  // キーワード検索
  const _onKeyDown = useCallback(
    (e) => {
      if (e.keyCode === 13) {
        loadSearchResult({ keyword: keywordDisp });
        return false;
      }
    },
    [loadSearchResult, keywordDisp]
  );
  return (
    <div 
      className="bg-white"
      style={{
        width: "70%",
      }}>
      <input
        type="text"
        className="m-search-textbox"
        style={{
          borderRadius: '6px',
          backgroundPosition: '5%',
          height: '40px',
        }}
        value={keywordDisp}
        placeholder="キーワードで探す"
        onChange={_onChangeKeyword}
        onKeyDown={_onKeyDown}
        autoComplete="on"
        list="mylist"
        inputMode="search"
      />
    </div>
  );
};
export default SearchFormForHeader;